export enum SourcingType {
	Supplier = 1,
	Production = 2,
	Distribution = 3,
	NotDefined = 4,
}
